
<template>
    <div class="center tablaFamiliares mt-2">
      <vs-row v-if="users[0]">
        <vs-col w="12">
            <vs-button
                class="ml-auto"
                success
                @click="activeAccesos =! activeAccesos"
            >
                <i class="fas fa-user-friends mr-2"></i> Crear accesos masivamente
            </vs-button>
        </vs-col>
      </vs-row>
      <vs-alert v-if="activeSinInfo">
        <template #title>
          No se encontro información
        </template>
      </vs-alert>
      <vs-table striped>
        <template #thead>
          <vs-tr style="vertical-align: top">
            <vs-th style="width: 30%">
              Familiar
            </vs-th>
            <vs-th style="width: 30%">
              Hijos en expediente
            </vs-th>
            <vs-th style="width: 25%">
              Acceso
            </vs-th>
            <vs-th style="width: 15%">
              Acciones
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
            class="divisionLineas"
          >
            <vs-td>
              <md-chip class="mini-chip text-uppercase mb-2" :class="colorParentesco(tr.parentesco)"><strong> {{tr.parentesco}}</strong></md-chip>
              <p class="mb-1"><strong>{{tr.fullName}}</strong></p>
              <p class="mb-0"><small>CORREO DE CONTACTO</small></p>
              <p class="mb-1"><strong>{{tr.correo}}</strong></p>
            </vs-td>
            <vs-td>
                <div v-for="(hijos, i) in tr.hijos" :key="i" class="divisionLineas">
                  <p class="mb-1"><strong>{{hijos.fullName}}</strong></p>
                  <p class="mb-0"><small>MATRÍCULA</small></p>
                  <p class="mb-1"><strong>{{hijos.matricula}}</strong></p>
                  <p class="mb-0"><small>INSTITUCIÓN</small></p>
                  <p class="mb-1"><strong>{{hijos.institucionActual.nombre}}</strong></p>
                </div>
            </vs-td>
            <vs-td>
              <p class="mb-0" v-if="tr.acceso">{{tr.acceso.name}}</p>
              <p v-if="tr.acceso"><strong>{{tr.acceso.email}}</strong></p>
                <p class="mb-0"><small>Hijos vinculados a cuenta</small></p>
              <div v-if="tr.acceso" >
                <div v-for="(hijos, i) in tr.acceso.personas" :key="i" class="divisionLineas">
                  <p class="mb-1"><strong>{{hijos.persona.fullName}}</strong></p>
                </div>
              </div>

            </vs-td>
            <vs-td>
              <vs-button  v-if="tr.acceso"
                @click="activeEditar =! activeEditar; selectInfo = tr"
              >
                <i class="fas fa-edit mr-2"></i> Editar correo
              </vs-button>
              <vs-button v-if="tr.acceso"
                success
                blank
                :href="'/panel/user/'+window.btoa(tr.acceso.id)"
              >
                <i class="fas fa-external-link-alt mr-2"></i> Panel usuario
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay información
        </template>
        <template #footer>
            <vs-pagination  v-model="page" :length="pages" />
        </template>
      </vs-table>
      <editar-correo v-model="activeEditar" :info="selectInfo" :filtros="filtros" @refreshTable="getAccesoMasivoFamiliares"></editar-correo>
      <accesos-masivo v-model="activeAccesos" :filtros="filtros"></accesos-masivo>
    </div>
</template>
<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
import EditarCorreo from './modal/editar.vue'
import AccesosMasivo from './modal/acceso-masivo.vue'
export default {
  props: [
    'filtros',
    'ejecutar'
  ],
  data:() => ({
    page: 1, 
    max: 10,
    pages: 0,
    users: [],
    selectInfo: [],
    activeEditar: false,
    activeAccesos: false,
    activeSinInfo: false
  }),
  components:{
    EditarCorreo,
    AccesosMasivo
  },
  methods:{
    colorParentesco(parentesco){
      if(parentesco == 'madre'){
        return 'col-pink'
      }
      if(parentesco == 'padre'){
        return 'col-blue'
      }
      if(parentesco == 'otro'){
        return 'col-yellow'
      }
    },
    async getAccesoMasivoFamiliares(){
      const loading = this.$vs.loading()
      try{
          const params = {
              page: this.page,
              institucion_id: this.filtros.institucion,
              ciclo_escolar_id: this.filtros.cicloEscolar,
              status_acceso: this.filtros.estatus
          }
          
          if(this.filtros.grupo[0] == ''){
              const eliminar = this.filtros.grupo.shift()
              params.grupo_id = this.filtros.grupo
          }else{
              params.grupo_id = this.filtros.grupo
          }
          const { data : response } = await accesibilidad.getAccesoMasivoFamiliares(params)
          const { data: dataTable = [], per_page, total = 0 } = response || {}
          this.pages = Math.ceil(total/per_page) || 0
          this.users = dataTable
          this.activeSinInfo = dataTable[0] ? false : true
          loading.close()
      }
      catch(error){
          loading.close()
          this.$vs.notification({
              progress: 'auto',
              color: 'success',
              position: null,
              title: 'Se produjo un error',
              text: 'Favor de contactar al adminsitrador'
          })
      }
    }
  },
  watch:{
    filtros(){
      this.getAccesoMasivoFamiliares()
    },
    page () {
      this.getAccesoMasivoFamiliares()
    }
  }
}
</script>

<style>
  .tablaFamiliares .vs-table-content .vs-table table{
      margin: 1.7% 0 !important;
      width: 100% !important;
  }
</style>
<style scoped>
  .md-chip{
      height: 24px !important;
      line-height: 24px !important;
  }
  .col-blue{
      color: #2874A6;
      background: rgb(214, 234, 248);
  }

  .col-pink{
      color: #F08080;
      background: rgb(255, 236, 236);
  }

  .col-yellow{
      background: rgb(255, 248, 236);
      color: #febf3d;
  }
  .divisionLineas:not(:last-child){
      border-bottom: 1px solid #E5E7E9; 
  }
  .divisionLineas{
      padding: 2% 0;
  }
  .vs-table__tr{
    vertical-align: top;
  }
</style>

        